import { render, staticRenderFns } from "./ModalAccount2StepVerifyProgress.vue?vue&type=template&id=56a13920&scoped=true"
import script from "./ModalAccount2StepVerifyProgress.vue?vue&type=script&lang=js"
export * from "./ModalAccount2StepVerifyProgress.vue?vue&type=script&lang=js"
import style0 from "./ModalAccount2StepVerifyProgress.vue?vue&type=style&index=0&id=56a13920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a13920",
  null
  
)

export default component.exports